import { NavLink, useLocation } from 'react-router-dom';
import brandLogo from '../../assets/images/machandais-logo.png';
import brandLogoWhite from '../../assets/images/machandais-logo-white.png';

const NavbarBrand = ({ className }) => {
  const location = useLocation();

  return (
    <div className={`w-12 p-2 sm:p-1 sm:w-14 ${className}`}>
      <NavLink to="/">
        <img
          className="w-full"
          src={location.pathname === '/' ? brandLogo : brandLogoWhite}
          alt="Brand Logo"
        />
      </NavLink>
    </div>
  );
};

export default NavbarBrand;
